<ng-container *appI18nScopeReady>
  <div class="plant-switcher">
    <div class="plant-switcher__header">
      <span class="plant-switcher__title">{{ 'switch_plant' | i18n }}</span>
    </div>

    <ul class="plant-switcher__list">
      @for (plant of plants(); track plant.id) {
        @let isActive = projectService.currentProject()?.id === plant.id;
        <li
          class="plant-switcher__item"
          [class.plant-switcher__item--active]="isActive"
          [class.plant-switcher__item--clickable]="!isActive"
          [tabindex]="isActive ? -1 : 0"
          (click)="!isActive && openPlant(plant, $event)"
          (auxclick)="!isActive && openPlant(plant, $event)"
          (keydown.enter)="!isActive && openPlant(plant)"
        >
          <div class="plant-switcher__name">
            <mat-icon class="plant-switcher__factory-icon">{{ plant.isMultiPlant ? 'hub' : 'factory' }}</mat-icon>
            <span>{{ plant.name }}</span>
            @if (favoriteIds().has(plant.id)) {
              <mat-icon class="plant-switcher__favorite-icon" aria-hidden="true">star</mat-icon>
            }
          </div>
          <div class="plant-switcher__meta">
            <span class="plant-switcher__status-slot">
              @if (plant.isHealthLoading) {
                <mat-spinner [diameter]="14"></mat-spinner>
              } @else if (plant.status) {
                <span
                  class="plant-switcher__status"
                  [class.plant-switcher__status--online]="plant.status === plantStatusEnum.Online"
                  [class.plant-switcher__status--offline]="plant.status === plantStatusEnum.Offline"
                  [class.plant-switcher__status--inactive]="plant.status === plantStatusEnum.Inactive"
                >
                  <span class="plant-switcher__status-dot"></span>
                  {{ plant.status }}
                </span>
              } @else {
                <span class="plant-switcher__dash">—</span>
              }
            </span>
            <span class="plant-switcher__role">{{ plant.role }}</span>
            <mat-icon
              class="plant-switcher__check-icon"
              [class.plant-switcher__check-icon--hidden]="!isActive"
            >check_circle</mat-icon>
          </div>
        </li>
      }
    </ul>

    <div class="plant-switcher__footer">
      <button class="plant-switcher__view-all-btn" (click)="navigateToDetailedList()">
        <mat-icon>open_in_new</mat-icon>
        {{ 'view_detailed_list' | i18n }}
      </button>
    </div>
  </div>
</ng-container>
